// src/app/pages/admin/AdminMarcacionRemisionPotencialWrapper.tsx
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { PageTitle } from '../../../_metronic/layout/core';
import BackButton from '../../components/BackButton/BackButton';
import { LoadingBackdrop } from '../../components/LoadingSpinner/LoadingSpinner';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import BusquedaCandidatoTable from '../../components/MarcacionPotencialRemision/BusquedaCandidatoTable';
import MarcacionVacanteCandidatoTable from '../../components/MarcacionPotencialRemision/MarcacionVacanteCandidatoTable';
import { CandidatoBusqueda } from './EventosEmpleabilidad.helpers';
import { useAuth } from '../../modules/auth';


interface MarcacionRemisionPotencialWrapperProps {
	readOnly?: boolean;
}

const MarcacionRemisionPotencialPage = ({ readOnly = false }: MarcacionRemisionPotencialWrapperProps) => {
	const { id: eventoId } = useParams();
	const { isAdminRole, isEmployerRole } = useAuth();

	const EVENTOS_LIST_PATH = isAdminRole()
		? '/admin/gestion-eventos'
		: isEmployerRole()
		? '/empleador/gestion-eventos'
		: '/consejero/gestion-eventos';
	const [candidatoSeleccionado, setCandidatoSeleccionado] = useState<CandidatoBusqueda | null>(null);

	// TODO: cuando armemos el modal de hoja de vida, este estado guarda
	// el candidato a mostrar en modo lectura (panel/dialog separado).
	// const [candidatoHojaVida, setCandidatoHojaVida] = useState<CandidatoBusqueda | null>(null);

	const [open, setOpen] = useState(false);
	const [alert, setAlert] = useState(true);
	const [alertMsg, setAlertMsg] = useState('');

	const notify = (msg: string, success = true) => {
		setAlert(success);
		setAlertMsg(msg);
		setOpen(true);
		setTimeout(() => setOpen(false), 3000);
	};

	if (!eventoId) return null;

	return (
		<div className='p-4 shadow-4 rounded-3 mt-15' style={{ backgroundColor: '#FFFF' }}>
			<div className='row mb-4' style={{ alignItems: 'center' }}>
				<div className='col-sm-12 d-flex align-items-center' style={{ gap: '15px' }}>
					<BackButton to={EVENTOS_LIST_PATH} />
					<h2 className='m-0'>Marcación remisión potencial</h2>
				</div>
			</div>

			<BusquedaCandidatoTable
				eventoId={eventoId}
				readOnly={readOnly}
				onError={(msg) => notify(msg, false)}
				onVerHojaVida={(c) => {
					// TODO: abrir modal de hoja de vida (siguiente paso)
				}}
				onVerAsociacion={(c) => setCandidatoSeleccionado(c)}
			/>

			{candidatoSeleccionado && (
				<div style={{ marginTop: 24 }}>
					<MarcacionVacanteCandidatoTable
						eventoId={eventoId}
						candidato={candidatoSeleccionado}
						readOnly={readOnly}
						onError={(msg) => notify(msg, false)}
						onSuccess={(msg) => notify(msg, true)}
						onGuardado={() => setCandidatoSeleccionado(null)}
					/>
				</div>
			)}

			<Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} onClose={() => setOpen(false)}>
				<Alert onClose={() => setOpen(false)} variant='filled' severity={alert ? 'success' : 'error'} sx={{ whiteSpace: 'pre-line' }}>
					{alert ? <AlertTitle>Éxito</AlertTitle> : <AlertTitle>Error</AlertTitle>}
					{alertMsg}
				</Alert>
			</Snackbar>
		</div>
	);
};

const AdminMarcacionRemisionPotencialWrapper = (props: MarcacionRemisionPotencialWrapperProps) => {
	return (
		<>
			<PageTitle breadcrumbs={[]}>Marcación remisión potencial</PageTitle>
			<MarcacionRemisionPotencialPage {...props} />
		</>
	);
};

export { AdminMarcacionRemisionPotencialWrapper, MarcacionRemisionPotencialPage };